import s from './Loader.module.css';

type LoaderProps = {
  background?: boolean;
};

export const Loader = ({ background = false }: LoaderProps) => {
  return (
    <div className={`${s.loader} ${background ? s.background : ''}`}></div>
  );
};
